const orderGrid = {
    orderGridEletricity: function (data) {
        const stateOrder = [
            "United Kingdom",
            "Germany",
            "Netherlands",
            "France",
            "Italy",
            "Ireland",
            "Northern Ireland",
            "Belgium",
            "Austria",
            "Bulgaria",
            "Spain",
            "Czech Rep.",
            "Slovakia",
            "Hungary",
            "Switzerland",
            "Poland",
            "Romania",
            "Estonia",
            "Lithuania",
            "Luxembourg"
        ];

        const stateMap = {};
        const restOfWorldMap = new Map();

        for (var i = 0; i < data.length; i++) {
            if (stateOrder.includes(data[i].state)) {
                stateMap[data[i].state] = data[i];
            } else {
                restOfWorldMap.set(data[i].priceAreaName, data[i]);
            }
        }

        const restOfWorld = Array.from(restOfWorldMap.values()).sort(function (a, b) {
            let x = a.state.toLowerCase();
            let y = b.state.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        });

        const ordered = stateOrder
            .filter(state => stateMap[state])
            .map(state => stateMap[state]);

        return [...ordered, ...restOfWorld];
    }
}

export default orderGrid;